import { Icon } from 'components/Icon';
import { FC, useState } from 'react';
import { Modal } from 'components';
import { VideoPreview } from 'components/VideoPreview';
import { instance } from 'utils/axiosConfig';
import { IItem } from 'types';

import videoIco from 'assets/sprite/video-ico.svg';
import eye from 'assets/sprite/eye.svg';

import styles from './Video.module.scss';

export const Video: FC<IItem> = ({ filename_download, isDownload, id, status, video_type }) => {
  const [isShow, setIsShow] = useState(false);
  const [isDownloaded, setIsDownloaded] = useState(isDownload);
  const [isReadyPlayer, setIsReadyPlayer] = useState(false);

  const handleClick = () => {
    instance.post(`/videos/download-log/${id}`, { video_id: id }).then(res => {
      if (res.status === 200) {
        setIsShow(true);
        setIsReadyPlayer(true);
      }
    });
    setIsDownloaded(true);
  };

  return (
    <>
      <div className={styles.root} onClick={handleClick}>
        <div className={styles.info}>
          <Icon id={videoIco.id} viewBox={videoIco.viewBox} className={styles.icoType} />
          <span className={styles.title} style={{ fontWeight: isDownloaded ? '400' : '700' }}>
            {filename_download}
          </span>
          {status && <span className={styles.status}>{status}</span>}
        </div>
        <div className={styles.actions}>
          <button className={styles.viewBtn}>
            <Icon id={eye.id} viewBox={eye.viewBox} className={styles.icoView} />
          </button>
        </div>
      </div>

      {isShow && (
        <Modal setIsShow={setIsShow}>
          {isReadyPlayer && <VideoPreview id={id} video_type={video_type} />}
        </Modal>
      )}
    </>
  );
};
